import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import Icon from 'atoms/icon';
import Input from 'atoms/input';
import toast from 'atoms/toast';
import {
  setCompleteItems,
  setIncompleteItems,
  setService,
} from 'store/reducers/checkout';

import AppointmentItemType from './AppointmentItemType';
import { getCompleteItems } from './util';

export default function AppointmentItem({
  rightColumnLabel,
  leftColumnLabel,
  className,
  item,
  disableDeletion,
  options,
  focus,
  isService,
}) {
  const dispatch = useDispatch();
  const { incompleteItems, service } = useSelector((state) => state.checkout);
  // User is trying to edit the price for an empty/incorrect service (ex; typed service vs selecting from dropdown)
  const isPriceDisabled = incompleteItems.some(
    (el) => el.uuid === item.uuid && !el.name && !el.isCustom
  );

  // Change service, add-on, or custom item's name
  const onChangeItemsName = (selectedItem) => {
    if (isService) {
      return dispatch(setService(selectedItem));
    }

    const updatedItems = incompleteItems.map((addOn) => {
      if (addOn.uuid === item.uuid) {
        if (item.isCustomItem) {
          // With custom items, you can change the name without affecting the price
          return { ...addOn, name: selectedItem };
        } else
          return {
            // With add ons, if a new one is selected, its price also gets applied.
            // Price can be modified afterwards
            name: selectedItem.name,
            price: selectedItem.price,
            uuid: selectedItem.uuid,
          };
      }
      return addOn;
    });

    dispatch(setIncompleteItems(updatedItems));
    const completeItems = getCompleteItems(updatedItems);
    dispatch(setCompleteItems(completeItems));
  };

  // Modify service, add-on or custom item price
  const onChangePrice = (amount) => {
    if (isPriceDisabled) {
      return toast({ text: 'Select a service from the dropdown' });
    }
    const updatedPrice = { amount: +amount, localized: `$${amount}` };

    if (isService) {
      return dispatch(setService({ ...service, price: updatedPrice }));
    }

    const updatedItems = incompleteItems.map((addOn, i) => {
      if (addOn.uuid === item.uuid) {
        return { ...addOn, price: updatedPrice };
      }
      return addOn;
    });

    dispatch(setIncompleteItems(updatedItems));
    const completeItems = getCompleteItems(updatedItems);
    dispatch(setCompleteItems(completeItems));
  };

  // Remove add-on or custom items
  const onRemoveItem = (uuid, name) => {
    const updatedItems = incompleteItems
      .filter((addOn) => addOn?.uuid !== uuid)
      .filter(Boolean);
    dispatch(setIncompleteItems(updatedItems));

    if (name) dispatch(setCompleteItems(updatedItems));
  };

  return (
    <div className={classNames('flex-column', className)}>
      <div className="flex-row justify-between">
        {leftColumnLabel && <p className="bold mb-8">{leftColumnLabel}</p>}
        {rightColumnLabel && <p className="bold mb-8">{rightColumnLabel}</p>}
      </div>
      <div className="flex-row justify-between service-item">
        <div className="left-column w-100 pos-relative">
          <AppointmentItemType
            item={item}
            options={options}
            onChange={onChangeItemsName}
            focus={focus}
          />
          {!disableDeletion && (
            <Icon
              name="bin"
              className="pos-absolute"
              onClick={() => onRemoveItem(item?.uuid, item?.name)}
            />
          )}
        </div>
        <Input
          className="service-item-price"
          isMoney
          textAlignment="right"
          placeholder="0.00"
          variant="white"
          size="small"
          onChange={onChangePrice}
          value={item?.price?.amount}
          disableInternalValue
        />
      </div>
    </div>
  );
}
